import { plPL } from '@mui/material/locale';
import { createTheme } from '@mui/material/styles';

import { components } from '@/config/theme/components.ts';
import {
  KnowMeTypography,
  KnowMeTypographyOverrides,
  typography,
} from '@/config/theme/typography.ts';

import { themeColors } from './themeColors.ts';

export const SIDE_MENU_WIDTH = '80px';
export const MAX_WIDTH = '1440px';

declare module '@mui/material/styles' {
  interface Theme {
    colors: typeof themeColors;
  }

  // allow configuration using `createTheme`
  interface ThemeOptions {
    colors: Partial<typeof themeColors>;
  }
}

declare module '@mui/material/styles' {
  interface TypographyVariants extends KnowMeTypography {}

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions extends Partial<KnowMeTypography> {}
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides extends KnowMeTypographyOverrides {}
}

export const knowMeTheme = createTheme(
  {
    colors: themeColors,
    components,
    palette: {
      primary: {
        ...themeColors,
        main: '#fff',
      },
      warning: {
        main: themeColors.orange,
      },
    },
    typography,
  },
  plPL,
);
